var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"receipt-88"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.deliveryHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }